import '../../httpservices/core/ajax.httpservice.core';

class EthicsConsultationHttpService {

    GetEthicsConsultationData() {
        return $.get('Patient/EthicsConsultation/GetEthicsConsultationData');
    }

    GetPatientandProxyContactData() {
        return $.get('Patient/EthicsConsultation/GetPatientandProxyContactData');
    }

    SendEthicsConsultationPsm(ethicsConsultationData) {
        return $.post('Patient/EthicsConsultation/SendEthicsConsultationPsm', ethicsConsultationData);
    }

    ComposeMessagePageInit() {
        return $.get('Patient/EthicsConsultation/EthicsConsultationFormInit');
    }

}

export const EthicsConsultationHttpSvc = new EthicsConsultationHttpService();